// A time typed into a time box the way people write one: "3pm", "3 PM", "3:00 PM", "3:30p", "3:30 p.m.", "15:00".
// The list's own "3:00pm" the picker reads itself; these it threw away (Petr).
const TWELVE_HOUR = /^(\d{1,2})(?::(\d{2}))?\s*([ap])\.?\s*(?:m\.?)?$/i;
const TWENTY_FOUR_HOUR = /^(\d{1,2}):(\d{2})$/;

export const parseTypedTime = (text: string): { hours: number; minutes: number } | null => {
  const typed = text.trim();
  const twelve = typed.match(TWELVE_HOUR);
  if (twelve) {
    const hour = Number(twelve[1]);
    const minutes = Number(twelve[2] || 0);
    if (hour < 1 || hour > 12 || minutes > 59) return null;
    const pm = twelve[3].toLowerCase() === 'p';
    return { hours: (hour % 12) + (pm ? 12 : 0), minutes };
  }
  const twentyFour = typed.match(TWENTY_FOUR_HOUR);
  if (twentyFour) {
    const hours = Number(twentyFour[1]);
    const minutes = Number(twentyFour[2]);
    if (hours > 23 || minutes > 59) return null;
    return { hours, minutes };
  }
  return null;
};
